import {Component, inject} from '@angular/core';
import {SupportApiService} from '../../services/support-api.service';
import {map} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AsyncPipe} from '@angular/common';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {MatIcon} from '@angular/material/icon';
import {Router, RouterLink} from '@angular/router';
import {SharedDataService} from '../../services/shared-data.service';
import {NgArrayPipesModule} from 'ngx-pipes';
import {SessionStorage, SessionStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-support-enter',
  imports: [
    AsyncPipe,
    TopBarComponent,
    MatIcon,
    RouterLink,
    NgArrayPipesModule
  ],
  templateUrl: './support-enter.component.html',
  styleUrl: './support-enter.component.scss'
})
export class SupportEnterComponent {
  private supportApiService: SupportApiService = inject(SupportApiService);
  public sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private router: Router = inject(Router);
  public departments$ = this.supportApiService.getDepartments()
    .pipe(
      map(data => {
        return data?.data;
      }),
      takeUntilDestroyed()
    );

  public navigateToDepartment(department_uuid: string, display_name: string) {
    this.router.navigate([`/departments`], {queryParams: {display_name, department_uuid}});
  }
  public navigateToChats() {
    this.router.navigate([`/chat-list`]);
  }

}
